@use '../../../global/host-utils.scss';

$component-size-L: 48px; // in figma: big
$component-size-M: 40px; // in figma: medium
$component-size-S: 32px; // in figma: not used
$component-size-XS: 24px; // in figma: small

:host {
  @include host-utils.ipl-host-reset;
  display: block;
}

// preset size
.component-element {
  --component-size: #{$component-size-L};
  &.M {
    --component-size: #{$component-size-M};
  }
  &.S {
    --component-size: #{$component-size-S};
  }
  &.XS {
    --component-size: #{$component-size-XS};
  }
}

.component-wrapper {
  .component-element {
    display: flex;
    align-items: center;
    gap: 7px;
    width: max-content;
    padding-left: 3px;
    padding-right: 3px;
    border: 1px solid var(--texttoggle-stroke-default);
    background-color: var(--texttoggle-surface-default);
    color: var(--texttoggle-text-default);
    fill: var(--texttoggle-text-default);

    // size
    height: var(--component-size);
    &.XS {
      gap: 5px;
      padding-left: 2px;
      padding-right: 2px;
    }

    &:focus-within:not(.disabled) {
      outline: 2px solid var(--texttoggle-stroke-focus);
      outline-offset: -2px;
      border-radius: 0px;
    }

    &.disabled {
      border: 1px solid var(--texttoggle-stroke-disabled);
    }
  }
}
